import { DropDownItem, Icon } from "MODULES/shared/components";
import PropTypes from "prop-types";
import React from "react";
import { renderIf } from "MODULES/shared/decorators";

function Transfer({ toggleRequestModal }) {
  return (
    <DropDownItem onClick={toggleRequestModal}>
      <Icon name="undo" fixed />
      Drop ship to another repair station
    </DropDownItem>
  );
}

export const canTransfer = ({ lineItem }) =>
  lineItem.shipped &&
  !lineItem.received &&
  !lineItem.cancelled &&
  (lineItem.approval_status === "repair_evaluation_rejected" ||
    lineItem.approval_status === "repair_evaluation_approved");

export default renderIf(canTransfer)(Transfer);
Transfer.propTypes = {
  toggleRequestModal: PropTypes.func.isRequired
};



// WEBPACK FOOTER //
// ./app/modules/RepairOrders/components/Detail/LineItems/LineItemControls/Transfer/Transfer.jsx